import {useChatStore, useUserStore} from '@/stores'
import {useRepository, useSound} from '@/composables'
import {chat, toWsMessage} from '@/messages'
import {mediator} from '@communication'
import {useEventBus} from '@vueuse/core'

const sortMessagesByTimestamp = (messages: any[]) => {
  return messages.sort((a, b) => {
    const timeA = new Date(a.timestamp).getTime()
    const timeB = new Date(b.timestamp).getTime()
    return timeA - timeB
  })
}
export const useChatCallback = () => {
  const {playSound} = useSound(['notification'])
  const chatStore = useChatStore()
  const userStore = useUserStore()

  useEventBus('chat:message').on((event: any) => {
    const {text} = event
    const previewLength = 30
    const preview = text.length < previewLength ? text : text.substring(0, previewLength - 3) + '...'
    playSound('notification')
    chatStore.addMessage({...event, author: 'counterparty'})
    chatStore.previewMessage(preview)
  })

  useEventBus('chat:history').on((event: any) => {
    const history = JSON.parse(event.history)
    chatStore.clearMessages()
    const sortedMessages = sortMessagesByTimestamp(history)
    sortedMessages.forEach(item => {
      chatStore.addMessage({...item, author: userStore.id === item.partyId ? 'party' : 'counterparty'})
    })
  })
  useEventBus('websocket:reconnecting').on(() => {
    const isDisabledChat = true
    chatStore.updateStatusChat(isDisabledChat)
  })

  useEventBus('websocket:reconnected').on(() => {
    const isDisabledChat = false
    chatStore.updateStatusChat(isDisabledChat)
  })
}
export const useChat = () => {
  const chatStore = useChatStore()
  const sendChat = (data: any) => {
    const {sendWsEvent} = useRepository()
    chatStore.addMessage({...data, author: 'party'})
    const message = chat.chatMessage(data)
    mediator.broadcast(message)
    sendWsEvent(toWsMessage(message))
  }
  return {sendChat}
}
